import { render, staticRenderFns } from "./BodyPartFilter.vue?vue&type=template&id=180a520b&"
import script from "./BodyPartFilter.vue?vue&type=script&lang=js&"
export * from "./BodyPartFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports